<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <DialogNovoUsuario
                :user="user"
                @closed="closedDialog"
                @updated="updatedCreateEdit"
                :editUser="editUserObj"
                :float-right="true"
                :dialogStatus="editUserDialog"
              />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="filters.searchText"
                    label="Nome"
                    clearable
                    density="compact"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                    :items="[50, 100, 200, 500]"
                    v-model="filters.itemsPerPage"
                    label="Resultados por página"
                    density="compact"
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"
                  ><v-icon class="mr-2">mdi-broom</v-icon>Limpar pesquisa</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submitSearch" type="submit"
                  ><v-icon class="mr-2">mdi-magnify</v-icon>Pesquisar</v-btn
                >
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Usuários de sistema
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="searchFilter"
              append-inner-icon="mdi-magnify"
              label="Filtrar resultados"
              clearable
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="lstUsers"
            :search="searchFilter"
            item-value="name"
            class="elevation-1"
            hide-default-footer
          >
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                  :disabled="requestingApi"
                  v-model="page"
                  :length="maxPage"
                ></v-pagination>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editUser(item)">
                    <v-list-item-title><v-icon color="primary" class="mr-2">mdi-pencil</v-icon> Editar Usuário</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteUser(item)">
                    <v-list-item-title><v-icon color="red" class="mr-2">mdi-delete</v-icon> Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DialogNovoUsuario from '../components/DialogNovoUsuario.vue';
import api from '@/services'
export default {
  components: { DialogNovoUsuario },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "E-mail", key: "email", sortable: true },
        { title: "Cadastro", key: "legal_person.name", sortable: true },
        { title: "Data de cadastro", key: "created_at", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      lstUsers: [],
      filters: {
        withLegalPerson: true,
        itemsPerPage: 1,
      },
      editUserObj: null,
      editUserDialog: null,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() {},
  activated() {},
  methods: {
    editUser(user) {
      var vm = this
      vm.editUserObj = user
      vm.editUserDialog = true
    },
    deleteUser(user) {
      var vm = this
      let _confirm = confirm('Deseja realmente excluir este usuário?')
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.user
            .delete(user.id)
            .then(() => {
              let _ix_lp_from = vm.lstUsers.findIndex(x => x.id === user.id)
              vm.lstUsers.splice(_ix_lp_from, 1)
              vm.$notify({
                type: "success",
                text: "Removido com sucesso",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    updatedCreateEdit(object) {
      var vm = this;
      if (object) {
        if (!vm.editUserObj?.id) {
          vm.lstUsers.unshift(object);
        }
        vm.editUserObj = { ...object };
      }
    },
    closedDialog() {
      var vm = this;
      vm.editUserObj = {};
      vm.editUserDialog = false;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_users_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
    },
    submitSearch() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.user
          .list(vm.filters, vm.page)
          .then((result) => {
            vm.lstUsers = result?.data;
            vm.itemsPerPage = result?.per_page || vm.itemsPerPage;
            vm.maxPage = Math.ceil(
              (result?.total || 1) / (result?.per_page || 10)
            );
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_users_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      vm.submitSearch();
    },
  },
};
</script>